import {
  FETCH_ACTIVITY_SUGGESTIONS,
  FETCH_ACTIVITY_SUGGESTIONS_SUCCESS,
  FETCH_ACTIVITY_SUGGESTIONS_FAILURE,
  GENERATE_ACTIVITY_PLAN,
  GENERATE_ACTIVITY_PLAN_DONE,
  SET_PLANNER_BUSY,
} from "./constants";

const initialState = {
  isFetching: false,
  isGenerating: false,
  suggestions: null,
  drafts: [],
  activityTypes: [],
  builtAt: null,
  stale: false,
  aiUnavailable: false,
  aiReason: null,
  busyUuid: null,
  error: null,
};

const HomeActivityPlannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVITY_SUGGESTIONS:
      return { ...state, isFetching: true, error: null };
    case FETCH_ACTIVITY_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        suggestions: action.payload?.suggestions ?? [],
        drafts: action.payload?.drafts ?? [],
        activityTypes: action.payload?.activityTypes ?? state.activityTypes,
        builtAt: action.payload?.builtAt ?? state.builtAt,
        stale: action.payload?.stale ?? false,
        busyUuid: null,
      };
    case FETCH_ACTIVITY_SUGGESTIONS_FAILURE:
      return { ...state, isFetching: false, error: true, busyUuid: null };
    case GENERATE_ACTIVITY_PLAN:
      return {
        ...state,
        isGenerating: true,
        aiUnavailable: false,
        aiReason: null,
      };
    case GENERATE_ACTIVITY_PLAN_DONE:
      return {
        ...state,
        isGenerating: false,
        aiUnavailable: !!action.payload?.aiUnavailable,
        aiReason: action.payload?.reason ?? null,
      };
    case SET_PLANNER_BUSY:
      return { ...state, busyUuid: action.payload ?? null };
    default:
      return state;
  }
};

export default HomeActivityPlannerReducer;
